import { SpacingValue } from './_types';

type ResolveValueArgs = {
  value: string;
  directional?: SpacingValue;
  concrete?: SpacingValue;
};

export const resolveValue = ({
  value,
  directional,
  concrete,
}: ResolveValueArgs): string | number | undefined => {
  if (concrete !== undefined) {
    if (typeof concrete === 'string' || typeof concrete === 'number') {
      return concrete;
    }
    return concrete ? value : undefined;
  }
  if (directional !== undefined) {
    if (typeof directional === 'string' || typeof directional === 'number') {
      return directional;
    }
    return directional ? value : undefined;
  }
  return undefined;
};
